import { NxStatusIconType } from '@allianz/ng-aquila/icon';

export enum ModalType {
  DEFAULT = 'default',
  STATUS = 'status',
}

export type ModalLayoutConfig = {
  type: ModalType;
  title: string;
  status?: NxStatusIconType;
};
